import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';

import { spacing } from '@decisiv/design-tokens';
import color from '@decisiv/design-tokens/lib/color';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const HelpText = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base * 0.5)};
`;

export const DepotSelectorWrapper = styled(Flex)`
  flex-direction: column;
  background-color: ${toColorString(color.base.snowWhite)};
`;

export const TextFieldWrapper = styled.div`
  position: relative;

  & svg.chevron-icon {
    position: absolute;
    right: ${rem(spacing.base)};
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: ${toColorString(color.status.information.medium)};
  }
`;
